import { useAuth } from "../auth/AuthProvider";
import { getConfig } from "../config";

/** `optimyl:identity_source` claim value for internal Optimyl staff (Entra ID / Azure AD SSO). */
const INTERNAL_IDENTITY_SOURCE = "EntraID";

/**
 * Distinguishes internal Optimyl staff from external broker/employer users.
 *
 * Internal users authenticate through Entra ID; the OIDC profile carries the source
 * in the `optimyl:identity_source` claim. Anyone not from Entra ID is treated as
 * external. Centralized so FormPage, Header, and the review-mode rule share one
 * definition (ADO-3440).
 *
 * AUTH_ENABLED=false exists only in local dev (deployed configs always enable auth),
 * where the CRM Function's JWT bypass injects an internal principal — mirror that
 * here so the local portal exercises the internal editing flow rather than the
 * read-only external view of correction versions.
 */
export function useUserRole(): { isExternal: boolean } {
  const { user } = useAuth();
  if (!getConfig().AUTH_ENABLED) return { isExternal: false };
  const isExternal = user?.profile["optimyl:identity_source"] !== INTERNAL_IDENTITY_SOURCE;
  return { isExternal };
}
